import { createContext, Dispatch, SetStateAction } from "react";
import { SignUpView } from "../Components/Views/SignUpView";

export const ViewContext = createContext({
	currentView: SignUpView,
	setCurrentView: {} as Dispatch<SetStateAction<() => JSX.Element>>,
});
